export default __webpack_public_path__ + "static/media/heroImage9.60776732.webp";